import React from "react";
import { useParams } from "react-router-dom";
import callAPI from "../../../../../../api/apiCaller";
import Loading from "../../../../../../common/Loading";
import {
  convertToLinks,
  formatDate,
  formatDescription,
  formatsDescription,
} from "../../../../../../common/utils";
import {
  AnnouncementsContainer,
  AnnouncementHeader,
  Announcer,
  AnnouncerImage,
  AnnouncementInfo,
  AnnouncementEdit,
  AnnouncerName,
  AnnouncementTime,
  AnnouncementContent,
  ViewMoreSpan,
  NoAnnouncementContainer,
  NoAnnouncementInner,
  NoAnnouncementImage,
  NoAnnouncementText,
  ProgramImage,
} from "./styles";
import { Context } from "../../../../../../Store";
import SendAnnouncement from "../../../popups/SendAnnouncement";
import Button from "../../../../../../common/Button";
import Accordian from "../../../../../../common/Accordian";
import AnnouncementImage from "./assets/campaign.svg";

function Announcements({ editMode, refreshProgram }) {
  let params = useParams();
  const [announcements, setAnnouncements] = React.useState(null);
  const { state, dispatch } = React.useContext(Context);
  const [showFullContent, setShowFullContent] = React.useState(false);
  const [showEditAnnouncement, setShowEditAnnouncement] = React.useState(false);
  const [selectedAnnouncement, setSelectedAnnouncement] = React.useState(null);

  const formatDescription = (announcement) => {
    return showFullContent
      ? announcement.content
      : announcement.content.slice(0, 250);
  };

  React.useEffect(() => {
    setAnnouncements(null);
    callAPI(dispatch, "getProgramAnnouncements", {
      id: params.selectedProgram,
    }).then((info) => {
      if (info.isResponseOk) {
        setAnnouncements(info.data);
      } else setAnnouncements([]);
    });
  }, [params.selectedProgram]);

  if (announcements === null) {
    return <Loading loadingItem="Announcements" />;
  }
  return (
    <AnnouncementsContainer>
      {announcements.length === 0 ? (
        <NoAnnouncementContainer>
          <NoAnnouncementInner>
            <NoAnnouncementImage src={AnnouncementImage} />
            <NoAnnouncementText>
              There are no announcements in this program yet.
            </NoAnnouncementText>
          </NoAnnouncementInner>
        </NoAnnouncementContainer>
      ) : (
        <>
          <Accordian
            multiOpen
            defaultOpen
            collapsible={false}
            isTask={true}
            isAnnouncement={true}
            sections={announcements.map((announcement) => {
              return {
                title: (
                  <AnnouncementHeader>
                    <Announcer>
                      <AnnouncerImage
                        src={
                          announcement.user.image
                            ? announcement.user.image
                            : "https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_1280.png"
                        }
                      />
                      <AnnouncementInfo>
                        <AnnouncerName>
                          {announcement.user.firstName} &nbsp;
                          {announcement.user.lastName}
                        </AnnouncerName>
                        <AnnouncementTime>
                          {formatDate(announcement.createdAt)}
                        </AnnouncementTime>
                      </AnnouncementInfo>
                    </Announcer>

                    {editMode && (
                      <AnnouncementEdit>
                        <Button
                          icon="edit"
                          onClick={() =>
                            setShowEditAnnouncement(announcement.id)
                          }
                        />
                      </AnnouncementEdit>
                    )}
                  </AnnouncementHeader>
                ),
                content: (
                  //  <AnnouncementContent        >
                  // { selectedAnnouncement===announcement.id ? formatDescription(announcement): announcement.content.slice(0,250)}

                  // {announcement.content.length >250 &&<ViewMoreSpan icon="" onClick={()=>{
                  //   setShowFullContent(!showFullContent)
                  //   setSelectedAnnouncement(announcement.id)
                  //   }}>{showFullContent && selectedAnnouncement===announcement.id ? "Hide" :"View more"}</ViewMoreSpan>}
                  // </AnnouncementContent>

                  <AnnouncementContent>
                    {/* Render the announcement content with links converted */}
                    {/* <div dangerouslySetInnerHTML={{ __html: convertToLinks(selectedAnnouncement === announcement.id ? formatDescription(announcement) : announcement.content.slice(0, 250)) }} /> */}
                    <div
                      dangerouslySetInnerHTML={{
                        __html: `
      <style>
        div.description p{
          margin: 0;
        }
        div.description ol{
          margin: 0;
        }
        div.description ul{
          margin: 0;
        }
       div.description a{
        color: rgb(14 76 222 / 80%) !important;
       }
      
      </style>
      ${convertToLinks(
        selectedAnnouncement === announcement.id
          ? formatDescription(announcement)
          : announcement.content.slice(0, 250)
      )}
    `,
                      }}
                      className="description"
                    />
                    {/* Conditionally render the "View more" option */}
                    {announcement.content.length > 250 && (
                      <ViewMoreSpan
                        icon=""
                        onClick={() => {
                          setShowFullContent(!showFullContent);
                          setSelectedAnnouncement(announcement.id);
                        }}
                      >
                        {showFullContent &&
                        selectedAnnouncement === announcement.id
                          ? "Hide"
                          : "View more"}
                      </ViewMoreSpan>
                    )}
                  </AnnouncementContent>
                ),
                image: (
                  <>
                    {announcement?.image ? (
                      <ProgramImage
                        // src={`https://onemauve-v2.s3.us-east-2.amazonaws.com/${announcement?.image}`}
                        src={`${announcement?.image}`}
                      />
                    ) : null}
                  </>
                ),
              };
            })}
          />

          {showEditAnnouncement && (
            <SendAnnouncement
              announcementProgram={params.selectedProgram}
              announcementId={showEditAnnouncement}
              closeModal={(shouldRefresh) => {
                if (shouldRefresh) {
                  refreshProgram();
                }
                setShowEditAnnouncement(false);
              }}
            />
          )}
        </>
      )}
    </AnnouncementsContainer>
  );
}
export default Announcements;
